// extracted by mini-css-extract-plugin
export var content = "_ml-1";
export var fullScreen = "_ml-0";